import React, { useEffect, useState } from "react";
import { Privilege } from "@/api/privileges";
import RigthPanel from "@/ui-controls/RigthPanel";
import DeleteAppPrivilegeForm from "@/components/privileges/appPrivileges/DeleteAppPrivilegeForm";

interface Props {
  privilege: Privilege | undefined;
  onDelete: (privilege: Privilege) => any;
  onClose: () => any;
}

const DeleteAppPrivilegePanel = (props: Props) => {
  const [isPanelOpen, setIPanelOpen] = useState<boolean>(false);

  useEffect(() => {
    setIPanelOpen(props.privilege !== undefined);
  }, [props.privilege]);

  const onClosePanel = () => {
    setIPanelOpen(false);
    if (props.onClose) props.onClose();
  };

  return (
    <>
      <RigthPanel
        header="Delete Privilege"
        isOpen={isPanelOpen}
        dismissPanel={onClosePanel}
        childComponent={DeleteAppPrivilegeForm}
        childProps={{
          privilege: props.privilege,
          onClose: () => onClosePanel(),
          onDelete: (privilege: Privilege) => {
            props.onDelete(privilege);
            onClosePanel();
          },
        }}
      />
    </>
  );
};

export default DeleteAppPrivilegePanel;
